import store from './index'
import * as Session from "supertokens-web-js/recipe/session"
import { UserService } from "@/services/backend/UserService"
import { CustomerProfileService } from "@/services/backend/CustomerService"
import { getPendingBidsCountFromListings } from "@/services/backend/ListingService"
import { BidService } from "@/services/backend/BidService"
import { MessageService } from "@/services/backend/MessageService"

export const initAppStore = async () => {
    const isSession = await Session.doesSessionExist()
    store.commit('setUserLoggedIn', isSession)

    if (!isSession) return

    const userId = await UserService.getUserId()
    const user = await CustomerProfileService.getCustomerProfile(userId)
    if (user) store.commit('setProfile', user)

    const listingCount = await getPendingBidsCountFromListings(null)
    const bidCount = await BidService.getPendingBidsCountFromListings(null)
    const msgCount = await MessageService.getConversationsToRespondToCount()

    store.commit('setListingNotifications', listingCount)
    store.commit('setBidNotifications', bidCount)
    store.commit('setOrderMessageNotifications', msgCount)
}